/**
 * Requires a credentialed (non-anonymous) user on top of ProtectedRoute.
 */

import { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthContext'
import { ProtectedRoute } from '@/components/routing/ProtectedRoute'

interface KnownRouteProps {
  children: ReactNode
  skipOnboardingCheck?: boolean
}

export function KnownRoute({ children, skipOnboardingCheck = false }: KnownRouteProps) {
  const { isAnonymous } = useAuth()
  const location = useLocation()

  return (
    <ProtectedRoute skipOnboardingCheck={skipOnboardingCheck}>
      {isAnonymous ? <Navigate to="/auth/signup" state={{ from: location }} replace /> : children}
    </ProtectedRoute>
  )
}
